module.exports = __webpack_public_path__ + "img/ht.580bb7dc.svg";